import { updateMatchingNodesInTree } from '../../../components/Tree/helpers/helpers';
import { selectTreeDataByTreeId, updateData } from '../../selectors/tree/tree';

export const updatePropsInMatchingNodes =
  (tree, props, predicate, selectNodeAtPath) => async (dispatch, getState) => {
    const treeData = updateMatchingNodesInTree(
      predicate,
      selectTreeDataByTreeId(getState(), tree),
      props,
    );
    return dispatch(updateData(tree, treeData, { selectNodeAtPath }));
  };
